import {store} from '../../../store/store'
import ktCommon from './ktCommon'
import cstaKtDefs from './cstaKtDefs'
import apiEvent from '../apiEvent'
import eventBus from '@/event_bus'
import util from '../../index'

const isKT = () => util.parseLoginToken() && util.parseLoginToken().callServerType && util.parseLoginToken().callServerType.indexOf('KT') > -1

let callInfo = {
  brandDnis: '',
  callbackId: '',
  callbackType: '',
  callEvent: '',
  contactTypeId: '',
  direction: '',
  dnis: '',
  endTime: '',
  incomingChannel: '',
  isAgentClose: false,
  isAnonymous: false,
  isCallEnd: false,
  isCleared: false,
  isClose: false,
  isOriginatedEnd: false,
  isSummaryCompleted: true,
  memo: '',
  recordNo: '',
  serviceCode: '',
  startTime: '',
  tagList: [],
  taskData: {},
  ticketId: null,
  ticketStatus: '',
  userKey: ''
}

let agentCode = null
let webSocket = null
let callEvent = null
let direction = ''
let holdStatus = null
let outBoundCall = null
let isSpyCall = false

function getAgentCode () {
  return agentCode || store.getters.telNumber
}

function getAgentId () {
  return store.getters.agentId
}

function changeCallEvent (evtName) {
  callEvent = evtName
  store.commit('changeCallEvent', evtName)
}

/**
 * WebSocket 서버에 연결 하기
 * @KlConnect
 * @param {string} serverIp - WebSocket 서버 주소
 * @param {string} serverPort - WebSocket 서버 포트
 * @param {string} userId - Login할 전화(내선)번호
 * @param {object} handler - WebSocket 이벤트 콜백 객체
 * @returns {boolean} - 성공: true, 실패: false
 */

function KlStartMonitor () {
  callEvent = store.getters.callInfo.callEvent
  direction = store.getters.callInfo.direction
  store.commit('changeIsTelIng', true)
  store.commit('changeIsValidTel', true)
  store.commit('LOGIN_CALL')
  let values = {
    action: 'Ping'
  }

  changeCallEvent('startMonitor')

  let intervalObj = setInterval(() => {
    if (store.getters.IS_TEL_ING === false) {
      clearInterval(intervalObj)
      return false
    }
    if (store.getters.pingTryCount < 5) {
      store.commit('increasePingTryCnt')
      sendMessage(values)
    } else {
      clearInterval(intervalObj)
      setTimeout(() => {
        eventBus.$emit('call-reconnect-start')
      }, 3000)
    }
  }, 60000)
}

/**
 * WebSocket 연결 해제 하기
 * KlDisconnect
 * @returns {boolean} - 성공: true, 실패: false
 */
function KlDisconnect () {
  if (webSocket !== null) {
    webSocket.close()
    webSocket = null
  }
}

/**
 * 외부 전화 걸기
 * KlExternalCall
 * @param {string} callnumber - 전화할 상대 외부 전화번호
 * @returns {boolean} - 성공: true, 실패: false
 */
function KlExternalCall (callnumber, serviceNumber) {
  outBoundCall = callnumber
  changeCallEvent('Originate')
  const rid = serviceNumber.split('-').join('')
  let values = {
    action: 'Originate',
    dial_number: callnumber,
    rid_number: rid
  }
  store.commit('changeDnis', rid)
  return sendMessage(values)
}

/**
 * 내부 전화 걸기
 * KlInternalCall
 * @param {string} callnumber - 전화할 상대 외부 전화번호
 * @returns {boolean} - 성공: true, 실패: false
 */
function KlInternalCall (callnumber) {
  let values = {
    action: 'Originate',
    dial_number: callnumber
  }

  return sendMessage(values)
}

/**
 * 전화 받기
 * KlAnswer
 * @param {string} callnumber - 전화할 상대 외부 전화번호
 * @returns {boolean} - 성공: true, 실패: false
 */
function KlAnswer () {
  let values = {
    action: 'Answer'
  }

  return sendMessage(values)
}

/**
 * 통화 보류
 * KlHold
 * @param {boolean} hold - true: 통화보류, false: 통화 보류 해제
 * @returns {boolean} - 성공: true, 실패: false
 */
function KlHold (hold) {
  if (holdStatus !== hold) {
    holdStatus = hold
    let values = {
      action: 'HoldAudio',
      option: holdStatus ? 'on' : 'off'
    }

    return sendMessage(values)
  }
}

/**
 * 음소거
 * KlMute
 * @param {boolean} hold - true: 음소거, false: 음소거 해제
 * @returns {boolean} - 성공: true, 실패: false
 */
function KlMute (mute) {
  const agtCode = getAgentCode()
  let command = null
  if (mute) {
    command = 'MuteAudio ' + agtCode + ' on'
  } else {
    command = 'MuteAudio ' + agtCode + ' off'
  }
  return sendMessage(command)
}

/**
 * 통화 당겨받기
 * KlPickup
 * @returns {boolean} - 성공: true, 실패: false
 */
function KlPickup () {
  let values = {
    action: 'PickupCall'
  }

  return sendMessage(values)
}

/**
 * 통화 전달하기
 * KlTransfer
 * @param {string} type - 'a': 협의 전달, 'b': 직접전달
 * @param {string} callnumber - 전달할 상대 전화번호
 * @returns {boolean} - 성공: true, 실패: false
 */
function KlTransfer (type, callnumber) {
  var command = type === 'a' ? 'Atxfer' : 'Blindxfer'

  let values = {
    action: command,
    trans_number: callnumber,
    context: 'transfer_call'
  }
  changeCallEvent('transfer')

  return sendMessage(values)
}

function KlTransferCancel () {
  let values = {
    action: 'Hangup',
    option: '2'
  }

  return sendMessage(values)
}
/**
 * 에이전트 상태 변경하기
 * KlAgentStatus
 * @param {string} status - 상태 변경 값
 * @returns {boolean} - 성공: true, 실패: false
 */
function KlAgentStatus (AgtMode, subStatus) {
  if (AgtMode === cstaKtDefs.AgentMode.AM_LOG_IN && ktCommon.IS_CHANGE_STATUS) {
    ktCommon.IS_CHANGE_STATUS = false
  } else if (AgtMode === cstaKtDefs.AgentMode.AM_WORK_NOT_READY) {
    ktCommon.IS_CHANGE_STATUS = false
  }

  if (ktCommon.IS_CHANGE_STATUS) {
    setTimeout((AgtMode, subStatus) => {
      KlAgentStatus(AgtMode, subStatus)
    }, 500)
    return false
  }

  let status = 0
  if (!isNaN(AgtMode)) {
    if (subStatus) {
      const mode = `${AgtMode}_${subStatus}`
      if (isKT()) {
        status = String(cstaKtDefs.NumberAgentMode[mode] || mode)
      } else {
        status = String(cstaKtDefs.NumberAgentMode[mode] || mode)
      }
    } else {
      status = String(cstaKtDefs.AgentMode[AgtMode] || AgtMode)
    }
  } else {
    status = String(cstaKtDefs.AgentMode[AgtMode])
  }

  ktCommon.IS_CHANGE_STATUS = true
  if (AgtMode < 0 || AgtMode > 18) {
    return false
  }
  let values = {
    action: 'SetAgentState',
    option: status
  }

  return sendMessage(values)
}

/**
 * 전화상태 확인하기
 * KlAgentStatus
 * @param {string} callnumber - 상태확인 전화번호(옵션)
 * @returns {boolean} - 성공: true, 실패: false
 */
function KlCallStatus () {
  let values = {
    action: 'GetAgentState',
    option: 2
  }

  return sendMessage(values)
}

/**
 * 통화를 직접 컨트롤 하기
 * KlSpyCall
 * @param {string} callnumber - 컨트롤 전화번호 (내선번호)
 * @param {string} option - 컨트롤 타입(감청하기 'b', 코칭하기 'w')
 * @returns {boolean} - 성공: true, 실패: false
 */
function KlSpyCall (callnumber, option) {
  changeCallEvent('spyCall')
  let values = {
    action: 'SpyCall',
    target_number: callnumber,
    option: option
  }

  return sendMessage(values)
}

/**
 * 통화 끊기
 * KlHangup
 * @returns {boolean} - 성공: true, 실패: false
 */
function KlHangup () {
  let values = {
    action: 'Hangup',
    option: 1
  }

  return sendMessage(values)
}

/**
 * 웹소켓 메세지 발송
 * sendMessage
 * @param {string} message - WebSocket에 메세지 전송
 * @returns {boolean} - 성공: true, 실패: false
 */
function sendMessage (msg) {
  let result = true
  const message = msg.action ? Object.assign(msg, { extension: getAgentCode() }) : msg

  try {
    store.commit('sendMessageToCallSocket', message ? JSON.stringify(message) : null)
  } catch (e) {
    console.log('send error : ' + e)
    return !result
  }
  return result
}

function doHangup () {
  const callStatus = localStorage.getItem('call-agent-status')
  if (JSON.parse(callStatus).status !== '通話中') { return }

  apiEvent.buttonState(cstaKtDefs.STATE_NREADY)
  store.commit('setIsTransferCancel', false)
  eventBus.$emit('call-connection', 'cleared')
  eventBus.$emit('send-service', '')
  eventBus.$emit('call-work-not-ready')
  window.sessionStorage.clear()
}

// add 20210720 Event 처리
function EventProc (rcvData) {
  if (!rcvData) return
  const { event, data, response } = rcvData

  if (event) {
    switch (event) {
      case 'SetAgentStateAction':
        ktCommon.IS_CHANGE_STATUS = false
        let status = String(data.STATUS)
        if (response === 'Success') {
          // 통계 server에 I/O 구분값 보내주는 부분
          if ((status === '3') | (status === '8')) {
            const directionState = direction || store.getters.callInfo.direction || 'I'
            store.dispatch('send_status', {'agentId': getAgentId(), 'data': { status, 'ioType': directionState }})
          } else if (status === '4') {
            store.dispatch('send_status', {'agentId': getAgentId(), 'data': { status, 'ioType': 'O' }})
          } else if (status) {
            store.dispatch('send_status', {'agentId': getAgentId(), 'data': {status}})
          }

          // IB/OB 일때 후처리 이벤트 받을 때 통화 종료 처리
          if (status === '7') {
            if (callEvent === 'OriginateAction' || callEvent === 'AnswerAction') {
              changeCallEvent('Hangup')
              doHangup()
            }
          }
        }

        if (callEvent === 'startMonitor') {
          changeCallEvent(null)
          sendMessage({ action: 'Ping' })
        }
        break
      case 'Ringing':
        const callType = rcvData.calltype || 0
        window.sessionStorage.setItem('isCall', Date.now())
        eventBus.$emit('call-connection', 'originated')
        if (data) {
          if (isSpyCall) return

          let serviceCode = ''
          let channelUniqueVal = ''
          const dataObject = JSON.parse(data)

          KlAgentStatus(cstaKtDefs.AgentMode.AM_WORK_RINGING)

          // IB일 때
          if (callEvent !== 'OriginateAction') {
            serviceCode = decodeURIComponent(dataObject.queue_enc_name)
          }
          channelUniqueVal = dataObject.unique_id
          store.commit('setChannelUniqueKey', channelUniqueVal)

          if (dataObject.type && dataObject.type === 'transfer') {
            store.commit('setIsTransferCancel', true)
            changeCallEvent('transfer')
          }

          callInfo.serviceCode = serviceCode || ''
          store.commit('changeServiceCode', serviceCode)
          eventBus.$emit('send-service', serviceCode)
        }

        if ((callType === '1') || (callType === '4')) {
          const tempDrc = 'I'
          store.commit('changeDirection', tempDrc)
          direction = tempDrc

          apiEvent.buttonState(cstaKtDefs.STATE_DELIVERED_RECV)
          store.commit('changeCallUserKey', JSON.parse(data).cid)
          eventBus.$emit('call-bound:in', data)
        } else if (callType === '2') {
          apiEvent.buttonState(cstaKtDefs.STATE_DELIVERED_SEND)
          store.commit('changeCallUserKey', outBoundCall || 'notdefined')
          // IP 전화기로 직접 걸었을 때..
          if (!outBoundCall) {
            changeCallEvent('OriginateAction')
          }
          eventBus.$emit('call-bound:out', data)
          outBoundCall = null
        }

        break
      case 'AnswerAction':
        if (response === 'Success') {
          if (callEvent !== 'spyCall') {
            apiEvent.buttonState(cstaKtDefs.STATE_ESTABLISHED)
          }
          if ((callEvent !== 'spyCall') && (callEvent !== 'transfer')) {
            changeCallEvent('AnswerAction')
          }
          store.commit('changeStartTime', new Date().getTime())
        }
        break
      case 'OriginateAction':
        if (response === 'Success') {
          changeCallEvent('OriginateAction')
          const tempDrc = 'O'
          store.commit('changeDirection', tempDrc)
          direction = tempDrc
          KlAgentStatus(cstaKtDefs.AgentMode.AM_CALL)
        }
        break
      case 'Bridge':
        apiEvent.buttonState(cstaKtDefs.STATE_ESTABLISHED)
        const jsonData = JSON.parse(data)

        if (isNaN(store.getters.customerPhoneNumber)) {
          const { rid } = jsonData
          callInfo.dnis = rid
          store.commit('changeDnis', rid)
          store.dispatch('changeCallUserKey', jsonData['record_file'].split('_')[3])
        }

        switch (callEvent) {
          case 'AnswerAction':
            callInfo.userKey = jsonData.cid
            store.commit('changeRecordNo', jsonData['record_file'])
            break
          case 'OriginateAction':
            const { cid, rid } = jsonData
            callInfo.userKey = cid
            callInfo.brandDnis = rid
            callInfo.dnis = rid
            callInfo.recordNo = jsonData['record_file']
            store.commit('changeStartTime', new Date().getTime())
            store.commit('changeBrandDnis', rid)
            store.commit('changeRecordNo', jsonData['record_file'])
            break
        }
        break
      case 'TransferBridge':
        changeCallEvent('TransferBridge')
        apiEvent.endCall()
        eventBus.$emit('call-work-not-ready')
        eventBus.$emit('hidePopup', 'showTransferPopup')
        break
      case 'HoldAudioAction':
        if (response === 'Success') {
          if (holdStatus) {
            KlAgentStatus(cstaKtDefs.STATE_HOLD)
            apiEvent.buttonState(cstaKtDefs.STATE_HOLD)
          } else {
            KlAgentStatus(cstaKtDefs.AgentMode.AM_CALL)
            apiEvent.buttonState(cstaKtDefs.STATE_ESTABLISHED)
          }
        }
        break
      case 'Hangup':
        if (callEvent === 'Hangup') {
          eventBus.$emit('call-work-not-ready')
          changeCallEvent(null)
          direction = ''
        }
        doHangup()
        break
      case 'HangupAction':
        if (callEvent === 'spyCall') {
          apiEvent.setAgentState('AM_LOG_IN')
          store.commit('changeCallAgentStatus', '相談準備')
          store.commit('changeIsSummaryCompleted', true)
          apiEvent.buttonState(cstaKtDefs.AM_LOG_IN)
          changeCallEvent(null)
          isSpyCall = false
        } else if (callEvent === 'transfer') {
          changeCallEvent(null)
        } else {
          doHangup()
        }
        break
      case 'SpyCallAction':
        isSpyCall = rcvData.response === 'Success'
        break
      case 'SpyStart':
        if (isSpyCall) {
          KlAnswer()
        }
        break
      case 'PingAction':
        if (response === 'Success') {
          store.commit('resetPingTryCnt')
        }
        break
    }
  }
  localStorage.setItem('call-details-info', JSON.stringify(callInfo))
}

function initCallID () {
  callInfo.callId = 0
  callInfo.evt = 0
  callInfo.called_dn = ''
  callInfo.called_dn = ''
  callInfo.redirection_dn = ''
  callInfo.userInfo = ''
  callInfo.holdingdn = ''
  callInfo.localconnstate = 0
  callInfo.eventcause = 0
}

function setCallInfo (newVal) {
  callInfo = newVal
}

export default {
  KlStartMonitor,
  KlDisconnect,
  KlExternalCall,
  KlInternalCall,
  KlAnswer,
  KlHold,
  KlMute,
  KlPickup,
  KlTransfer,
  KlTransferCancel,
  KlAgentStatus,
  KlCallStatus,
  KlSpyCall,
  KlHangup,
  EventProc,
  initCallID,
  setCallInfo
}



// WEBPACK FOOTER //
// ./src/util/call/klCnsAPI/klCnsAPI.js